import { connect } from 'react-redux';
import ShortPlan from './ShortPlan';
import { isLineOFFSelector } from '../../../modules/Dashboard';

const mapStateToProps = state => ({
  isLineOFF: isLineOFFSelector(state),
});

export default connect(mapStateToProps)(ShortPlan);
